/**
 * This app is deployed at elevaplatform.org, so the marketing/legal pages are
 * same-origin static files served from public/ (no React needed to read
 * them). The paths must not change: the native apps hard-code them as
 * absolute https://elevaplatform.org/… URLs -
 *  - eleva-ios:      Eleva/Profile/SettingsScreen.swift, Eleva/Auth/Views/AgreementsScreen.swift
 *  - eleva-android:  feature/profile/SettingsScreen.kt,  feature/auth/AgreementsScreen.kt
 */
export const elevaLinks = {
  home: '/',
  about: '/about.html',
  features: '/features.html',
  creators: '/creators.html',
  contact: '/contact.html',
  download: '/download.html',
  legal: {
    termsOfService: '/legal/terms-of-service.html',
    privacyPolicy: '/legal/privacy-policy.html',
    communityGuidelines: '/legal/community-guidelines.html',
    childSafetyStandards: '/legal/child-safety-standards.html',
    cookiePolicy: '/legal/cookie-policy.html',
    monetisationPolicy: '/legal/monetisation-policy.html',
    virtualItemsPolicy: '/legal/virtual-items-policy.html',
    ambassadorProgramme: '/legal/ambassador-programme.html',
    kycDisclosure: '/legal/kyc-disclosure.html',
    eula: '/legal/eula.html',
    deleteAccount: '/legal/delete-account.html',
  },
} as const

export const appStores = {
  android: 'https://play.google.com/store/apps/details?id=org.elevaplatform.mobile.Eleva',
  // "Eleva Social" listing (App Store Connect adamId). Apple redirects to the
  // visitor's storefront path; the id form never goes stale on a rename.
  ios: 'https://apps.apple.com/app/id6787748315',
} as const

/** Registered-company details shown in legal footers (not translated). */
export const elevaCompany = {
  name: 'Eleva Platform Ltd',
  registration: 'Company No. 17158073',
  address: '4A Central Square, Liverpool, L31 0AQ, United Kingdom',
  privacyEmail: 'privacy@elevaplatform.org',
} as const
